module.exports = "<captain-page></captain-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appFleet/captain.html
// module id = 1366
// module chunks = 0